import React from 'react'
import { useStore } from 'store/useStore'
import { useHistory, useLocation } from 'react-router'
import LINKS from 'App.const'
import MuiMenu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

function Menu ({ anchorEl, handleMenuClose }) {
  const { sessionStore } = useStore()

  const history = useHistory()
  const location = useLocation()

  const onQuitHandler = async () => {
    const isActive = await sessionStore.checkSessionId()
    if (isActive) {
      await sessionStore.deleteSession()
    }
  }

  const logOut = () => {
    handleMenuClose()
    onQuitHandler()
  }

  const openSettings = () => {
    history.push({
      pathname: LINKS.MAIN.SETTINGS.path,
      state: {
        from: location.pathname
      }
    })
    handleMenuClose()
  }

  return (
    <MuiMenu
      id='simple-menu'
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={openSettings}>
        <FormattedMessage id='settings' defaultMessage='Settings' />
      </MenuItem>
      <MenuItem onClick={logOut}>
        <FormattedMessage id='log_out' defaultMessage='Log out' />
      </MenuItem>
    </MuiMenu>
  )
}

Menu.propTypes = {
  anchorEl: PropTypes.object,
  handleMenuClose: PropTypes.func.isRequired
}

export default Menu
